import api from "./api";
import { tokenStorage } from "../utils/tokenStorage";

function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("Geolocation is not supported on this device. Please use a different device."));
      return;
    }


    const timeoutId = setTimeout(() => {
      reject(new Error("Location request timed out. Please check your GPS and try again."));
    }, 15000);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(timeoutId);
        resolve(position);
      },
      (error) => {
        clearTimeout(timeoutId);
        let message = "Location is disabled! Please switch on the location service and reload the page.";
        
        switch(error.code) {
          case error.PERMISSION_DENIED:
            message = "Location permission denied. Please allow location access in your browser settings and reload.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Location information is unavailable. Please ensure GPS is enabled and try again.";
            break;
          case error.TIMEOUT:
            message = "Location request timed out. Please check your GPS signal and try again.";
            break;
          default:
            message = `Location error: ${error.message}`;
        }
        
        reject(new Error(message));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
}



const AttendanceService = { 

async getAttendanceHistory(username) {
  const token = tokenStorage.get();
  if (!token) {
    throw new Error("You're not logged in. Please sign in again.");
  }

  const { data } = await api.get("/QrRetrieve/GetAttendencebyid", {
    headers: {
      "X-My-Secret-Token": token,
    },
    params: {
      username: username
    }
  });

  return data;
},

  getCurrentPosition,

  async postAttendance({
    latitude,
    longitude,
    lid,
    bid,
    attendType,
    overNight,
  }) {
    const token = tokenStorage.get();
    if (!token) {
      throw new Error("You're not logged in. Please sign in again.");
    }

    const username = localStorage.getItem("username");
    const password = localStorage.getItem("password");

    if (!username || !password) {
      throw new Error("User credentials not found. Please login again.");
    }

    const { data } = await api.post("/QrRetrieve/PostUserLocation", null, {
      headers: {
        "X-My-Secret-Token": token,
      },
      params: {
        longitute: longitude, 
        latitute: latitude,  
        LocId: lid,
        BId: bid,
        attendType,
        overNight: overNight ? "Y" : "N",
        UserName: username,
        Password: password,
      },
    });

    return data;
  }
};



export default AttendanceService;